import axiosClient from "axios-client.js";
import { useEffect, useState } from "react";
import CardSx from "./components/CardSx.jsx";
import CardDx from "./components/CardDx.jsx";
import { useParams } from "react-router-dom";
import Loading from "components/loading/Loading";
import { ACTIVATION_TYPES, SOURCE_TYPES } from "utils/constants.js";
import ThirdCardSx from "./components/ThirdCardSx.jsx";
import SecondCardSx from "./components/SecondCardSx.jsx";

const ActivationDetails = () => {
    const { code } = useParams();

    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});
    const [state, setState] = useState(null);

    const source = state?.data?.source;

    useEffect(() => {
        setLoad(true);
        setMessage({});
        axiosClient
            .get("/activation/" + code)
            .then(({ data }) => {
                setLoad(false);
                setState(data);
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }, []);

    return (
        <>
            {load ? <Loading /> : null}

            <div className="flex gap-5">
                {message.hasOwnProperty("text") ? (
                    <div
                        className={
                            "mb-6 text-left text-base " +
                            (message.type === "SUCCESS"
                                ? "text-green-500"
                                : message.type === "ERROR"
                                ? "text-red-500"
                                : message.type === "WARNING"
                                ? "text-amber-500"
                                : null)
                        }
                    >
                        <p>{message.text}</p>
                    </div>
                ) : null}

                {state && (
                    <div className="flex grow flex-col gap-5">
                        <CardSx state={state} />

                        {state.type === ACTIVATION_TYPES.ONSITE && (
                            <SecondCardSx state={state} />
                        )}

                        <ThirdCardSx state={state} />
                    </div>
                )}

                {source !== SOURCE_TYPES.RESELLER && (
                    <div className="w-1/4">
                        {state && <CardDx state={state} />}
                    </div>
                )}
            </div>
        </>
    );
};

export default ActivationDetails;
